import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { PopupRef } from '@shared/services/popup/popup.ref';
import { StateService } from '@shared/services';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'thevatra-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationPopupComponent {
  constructor(private popupRef: PopupRef<ConfirmationPopupComponent>,
              public stateService: StateService,
              @Inject(MAT_DIALOG_DATA) public data: {message: string; confirmLabel: string; cancelLabel: string}
  ) {}

  public confirm(): void {
    this.popupRef.close(true);
  }

  public closePopup(prevent?: boolean): void {
    this.popupRef.close(prevent ? null : false);
  }
}
